/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LinkSelector } from "cms/links/link-selector";
import { Logger } from "cms/utils/log/logger";

const LinkSelectorWrapper = (props) => {

    const onLinkChange = props?.onLinkChange;
    const onLinkRemove = props?.onLinkRemoved;
    const link = props?.link;
    const setLink = props?.setLink;
    const AddComponent = props?.AddComponent;
    const DisplayComponent = props?.DisplayComponent;

    const onSelectLink = async (link) => {
        Logger.debug(link);
        setLink(link);
        onLinkChange(link);
    };
    const onLinkRemoved = async () => {
        setLink(undefined);
        onLinkRemove();
    };

    return (
        <LinkSelector
            AddComponent={AddComponent}
            DisplayComponent={DisplayComponent}
            link={link}
            setLink={setLink}
            onSelectLink={onSelectLink}
            onLinkRemoved={onLinkRemoved}
        />
    );
};

export { LinkSelectorWrapper };
